export default __webpack_public_path__ + "static/Gila Hacohen-b7e1346d37e92f1d4acb14820d32a28e.webp";